import React, { Component } from "react";
import { Formatter } from "@cgn/framework-ui-components/v1";
import style from "./DrawerStyle";

class Quesito extends Component {
  state = {
    hover: false,
  };

  onHover = () => {
    this.setState({ hover: true });
  };

  outHover = () => {
    this.setState({ hover: false });
  };

  render() {
    return (
      <div
        style={this.state.hover ? style.quesitoHover : style.quesito}
        onClick={() => this.props.onPreview(this.props.data.IdPratica)}
        onMouseEnter={this.onHover}
        onMouseLeave={this.outHover}
      >
        <b
          style={style.header}
          dangerouslySetInnerHTML={{ __html: this.props.data.Titolo }}
        ></b>
        <br />
        <i style={style.subHeader}>
          {this.props.data.Servizio} / {this.props.data.Categoria}
        </i>
        <br />
        <span style={style.data}>
          <Formatter valore={this.props.data.DataUltimoMessaggio} tipo="date" />{" "}
          alle{" "}
          <Formatter valore={this.props.data.DataUltimoMessaggio} tipo="hour" />{" "}
        </span>
      </div>
    );
  }
}

export default Quesito;
